import React from 'react'
import { ComponentExt } from '@utils/reactExt'
import logo from "@assets/img/xiaotian/aoac_logo.png"
import packageIcon from "@assets/img/xiaotian/package_icon.png"
import * as styles from "./style/index.scss"

export default class XiaoTianPackage extends ComponentExt<any, any> {
    state: { iccid: string; imei: string; packageInfo, hasGetQueryGoodsShelfInfo }
    constructor(props) {
        super(props)
        this.state = {
            iccid: '',
            imei: '',
            packageInfo: [],
            hasGetQueryGoodsShelfInfo: false
        }
    }


    openAOAC = () => {
        if ((window as any).jsbridge) {
            (window as any).jsbridge.startSmallApp({
                appid: "202411191820335276",
                url: "https://aoac.lenovoconnect.com/index.html#/mobileXiaoTian",
                title: "懂的智联",
                width: "1440",
                height: "900",
                minwidth: "1152",
                minheight: "720",
                data: `{"iccid":"${this.state.iccid}","imei":"${this.state.imei}"}`
            })
        }

    }

    async componentDidMount() {
        document.title = '流量查询'

        if ((window as any).jsbridge) {
            try {
                //coreappsRequest32 调用32位程序的插件
                var sn = await (window as any).jsbridge.coreappsRequest('NEWPLUGIN_WIN32MBNPLUGIN_HELLO', '')
                if (sn && sn != ',') {
                    this.setState({
                        iccid: sn.split(',')[0],
                        imei: sn.split(',')[1],
                    })
                    const res = await this.api.getQueryGoodsShelfInfo({
                        iccid: sn.split(',')[0],
                        esim: "0"
                    })
                    if (res) {
                        this.setState({
                            packageInfo: res,
                            hasGetQueryGoodsShelfInfo: true
                        })
                    }

                } else {
                    this.setState({
                        hasGetQueryGoodsShelfInfo: true,
                    })
                }
            } catch (error) {
                this.setState({
                    hasGetQueryGoodsShelfInfo: true,
                })
            }
        } else {
            this.setState({
                hasGetQueryGoodsShelfInfo: true,
            })
        }

    }
    render() {
        return (
            <>
                <div className={styles.Xiaotian} style={{ background: 'unset' }}>
                    {this.state.hasGetQueryGoodsShelfInfo && (
                        <>
                            {this.state.packageInfo.length != 0 && (
                                <div>
                                    <div className={styles.contentBuble}>
                                        好的，已为您找到<span className={styles.AIserver} onClick={() => this.openAOAC()}>#懂的智联</span>提供的服务中有以下套餐可供选择：
                                    </div>
                                    <div className={styles.aoacPackageBox} >
                                        {this.state.packageInfo.map((item) => {
                                            return <div className={styles.PackageBoxContent}>
                                                <div className={styles.aoacBoxPic}>
                                                    <img src={packageIcon} alt="" />
                                                </div>
                                                <div className={styles.aoacBoxTitle}>{item.goodsReleaseName}</div>
                                                <div className={styles.aoacBoxContent}>¥{item.releasePrice}</div>
                                                <div className={styles.aoacBoxSearch} onClick={() => this.openAOAC()}>查看</div>
                                            </div>
                                        })}

                                        <div className={styles.showMore} onClick={() => this.openAOAC()}>
                                            <div className={styles.more}>查看更多
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {this.state.packageInfo.length == 0 && (
                                <>
                                    <div className={styles.contentBuble}>抱歉，暂未查询到套餐信息，已帮您找到相关服务，请选择：</div>
                                    <div className={styles.aoacBox} >
                                        <div className={styles.aoacBoxPic}>
                                            <img src={logo} alt="" />
                                        </div>
                                        <div className={styles.aoacBoxTitle}>懂的智联</div>
                                        <div className={styles.aoacBoxContent}>联想笔记本网络连接管理服务</div>
                                        <div className={styles.aoacBoxSearch} onClick={() => this.openAOAC()}>查看</div>
                                    </div>
                                </>
                            )}
                        </>
                    )}
                    {!this.state.hasGetQueryGoodsShelfInfo && (
                        <>
                            <div className={styles.contentBuble}>
                                好的，正在通过<span className={styles.AIserver} onClick={() => this.openAOAC()}>#懂的智联</span>为您查询中...
                            </div>
                            <div className={styles.contentBuble} style={{ marginTop: 12 }}>如需更多服务，请进入：</div>
                            <div className={styles.aoacBox} >
                                <div className={styles.aoacBoxPic}>
                                    <img src={logo} alt="" />
                                </div>
                                <div className={styles.aoacBoxTitle}>懂的智联</div>
                                <div className={styles.aoacBoxContent}>联想笔记本网络连接管理服务</div>
                                <div className={styles.aoacBoxSearch} onClick={() => this.openAOAC()}>查看</div>
                            </div>
                        </>
                    )}

                </div>


            </>
        )
    }
}
